import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';

import { bootstrapAuth } from './features/auth/auth.bootstrap';
import { env } from './lib/env';
import { initObservability } from './lib/observability';
import { router } from './router';
import './styles/index.css';

// Initialise Sentry + PostHog before anything else can throw. Both
// clients are no-ops when their env vars are unset (local dev), so
// this call is safe to make unconditionally.
initObservability({
  sentryDsn: env.sentryDsn,
  posthogKey: env.posthogKey,
  posthogHost: env.posthogHost,
  environment: import.meta.env.MODE,
  release: env.release,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element with id "root" was not found in index.html.');
}

const root = createRoot(rootElement);

// Resolve the initial auth session before rendering. This avoids a flash of
// the sign-in page for users who already have a valid Supabase session.
void bootstrapAuth().then(() => {
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
